
interface HeroSectionProps {
  onOpenQuoteModal: () => void;
  onOpenConsultationModal: () => void;
}

export default function HeroSection({ onOpenQuoteModal, onOpenConsultationModal }: HeroSectionProps) {
  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(31, 41, 55, 0.6)), url('https://public.readdy.ai/ai/img_res/b40f360f0a693b8e8e2c8490fcf686ed.jpg')`
      }}
    >
      <div className="container mx-auto px-4 w-full">
        <div className="max-w-3xl text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Votre partenaire comptable de confiance
            <span className="block text-gray-300">en Tunisie</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
            Cabinet EMA : Expert-comptable inscrit à l'ordre des experts comptables en France et en Tunisie. 
            Nous accompagnons les cabinets français dans leur externalisation comptable 
            avec expertise, qualité et confidentialité.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={onOpenConsultationModal}
              className="bg-gray-200 text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Planifier un entretien gratuit
            </button>
            <button 
              onClick={onOpenQuoteModal}
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-black transition-colors whitespace-nowrap cursor-pointer"
            >
              Demander un devis gratuit
            </button>
          </div>

          <div className="flex flex-wrap gap-8 text-sm opacity-80">
            <div className="flex items-center">
              <i className="ri-shield-check-line text-gray-300 mr-2"></i>
              Inscrit à l'ordre en France & Tunisie
            </div>
            <div className="flex items-center">
              <i className="ri-time-line text-gray-300 mr-2"></i>
              Disponible 6j/7
            </div>
            <div className="flex items-center">
              <i className="ri-secure-payment-line text-gray-300 mr-2"></i>
              Confidentialité garantie
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
